import React from 'react';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };
const font = "'DM Sans', sans-serif";
const STATUS_MAP = { pending:{ label:'Pendiente', color:'#999' }, progress:{ label:'En progreso', color:C.mango }, completed:{ label:'Completado', color:C.turquesa } };

export default function TaskItem({ task, onToggle, onStatusChange, canEdit, t }) {
  const st = STATUS_MAP[task.status] || STATUS_MAP.pending;
  const done = task.status === 'completed';
  const overdue = task.due_date && !done && new Date(task.due_date) < new Date();

  return (
    <div style={{
      display:'flex', alignItems:'center', gap:10, padding:'10px 14px', borderRadius:12,
      border:`0.5px solid ${done ? C.turquesa+'40' : overdue ? C.coral+'40' : t.border}`,
      background: done ? C.turquesa+'06' : overdue ? C.coral+'06' : 'transparent',
      marginBottom:6,
    }}>
      <div onClick={() => onToggle && onToggle(task)} style={{
        width:22, height:22, borderRadius:6, border:`2px solid ${done ? C.turquesa : t.border}`,
        background: done ? C.turquesa : 'none', display:'flex', alignItems:'center', justifyContent:'center',
        cursor:'pointer', flexShrink:0, transition:'all 0.2s',
      }}>
        {done && <span style={{ color:'#fff', fontSize:12, fontWeight:700 }}>✓</span>}
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <p style={{ fontSize:13, fontWeight:500, margin:0, textDecoration: done ? 'line-through' : 'none', opacity: done ? 0.6 : 1 }}>{task.title}</p>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginTop:3 }}>
          <span style={{ fontSize:10, color:t.textSecondary }}>{task.assigned_by === 'admin' || task.assigned_by === 'T&D' ? '👑 T&D' : `👤 ${task.assigned_by || 'Cliente'}`}</span>
          {task.due_date && <span style={{ fontSize:10, color: overdue ? C.coral : t.textSecondary }}>📅 {task.due_date}</span>}
          {task.completed_by && <span style={{ fontSize:10, color:C.turquesa }}>✓ {task.completed_by}</span>}
        </div>
      </div>
      {canEdit && !done && onStatusChange && (
        <select value={task.status} onChange={e => onStatusChange(task.id, e.target.value)} style={{
          fontSize:11, padding:'3px 6px', borderRadius:8, border:`0.5px solid ${t.border}`,
          background:t.card, color:st.color, fontWeight:600, fontFamily:font, cursor:'pointer', outline:'none',
        }}>
          <option value="pending">Pendiente</option>
          <option value="progress">En progreso</option>
          <option value="completed">Completado</option>
        </select>
      )}
    </div>
  );
}
